import { type ReactNode, useCallback, useState } from 'react';
import { getSnapshotsWithEnvironmentInfo } from '../../sources/flow';
import type { Environment } from '../../types/environment';
import type { ReleasedSnapshot } from '../../types/flow';
import { useNotificationDispatch } from '../notifications/NotificationProvider';

export interface FlowEditorSharedData {
    releases: ReleasedSnapshot[];
    environments: Environment[];
    loadReleases: () => void;
    isLoadingReleases: boolean;
}

interface Props {
    flowId: string;
    children: (props: FlowEditorSharedData) => ReactNode;
}

const FlowEditorSharedWrapper = ({ flowId, children }: Props) => {
    const [releases, setReleases] = useState<ReleasedSnapshot[]>([]);
    const [environments, setEnvironments] = useState<Environment[]>([]);
    const [isLoadingReleases, setIsLoadingReleases] = useState(true);
    const dispatchNotification = useNotificationDispatch();

    const loadReleases = useCallback(async () => {
        setIsLoadingReleases(true);
        try {
            const { releases, environments } = await getSnapshotsWithEnvironmentInfo(flowId);
            setReleases(releases);
            setEnvironments(environments);
            setIsLoadingReleases(false);
        } catch (error) {
            dispatchNotification({
                type: 'notifyError',
                payload: {
                    error,
                },
            });
            setIsLoadingReleases(false);
        }
    }, [flowId, dispatchNotification]);

    return (
        <>
            {children({
                releases,
                environments,
                loadReleases,
                isLoadingReleases,
            })}
        </>
    );
};

export default FlowEditorSharedWrapper;
